import { Component, EventEmitter, HostListener, OnInit, Output, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { changeLanguage } from 'src/app/redux/language/language.actions';
import { HomeService } from 'src/app/service/home.service';
import { ResponseStatus } from 'src/enum/responseEnum';
import { HttpClient } from '@angular/common/http';
import { CustomSnackbarService } from '../custom-notification/custom-notification.component';
import { LogoutService } from 'src/app/service/logout.service';
import { RegisterService } from 'src/app/service/register.service';
import { UtilityService } from 'src/app/service/utility.service';
import { ValidationDashService } from 'src/app/service/validation-dash.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  @Output() showSideMenu = new EventEmitter
  isLocationDivShow: boolean = false;
  toggleLocationDiv() {
    this.isLocationDivShow = !this.isLocationDivShow;
  }
  showLanguageSelection: boolean = false;

  searchedData: any;
  languageList: any = [];
  showLoading: boolean = false;
  showLoading1: boolean = false;
  showMsg: boolean = true;
  placeList: any = [];
  place: any;

  lat: any;
  lng: any;
  pinCode: any;
  city: any;
  country: any;
  village: any;

  address: any

  isMobile: boolean = false;

  activeRoute: number = 1;
  visible: boolean = false
  showSearchBox() {
    this.visible = !this.visible
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event: any) {
    this.showPopup(2, event);
    event.stopPropagation()
  }


  opened: any = false;
  showLocatoin: any = false;
  showLogoutOptoin: any = false;

  showPopup(id: any, event: any) {
    if (id == 1) {
      this.opened = true;
      this.showLogoutOptoin = false;
      if (this.showLocatoin) {
        this.showLocatoin = false;

      }
      event.stopPropagation();
    } else if (id == 3) {
      this.showLocatoin = true;
      this.showLogoutOptoin = false;
      if (this.opened) {
        this.opened = false;
      }
      event.stopPropagation();
    } else if (id == 4) {
      this.showLogoutOptoin = true;
      event.stopPropagation();
    } else {
      this.opened = false;
      this.showLocatoin = false;
      this.showLogoutOptoin = false;
    }
  }


  constructor(private router: Router,
    private homeService: HomeService, private logOut: LogoutService, private http: HttpClient,
    private customSnackbarService: CustomSnackbarService, private register: RegisterService,
    private utility: UtilityService, private renderer: Renderer2, public validationService: ValidationDashService) {

  }

  ngAfterViewInit(): void {
    this.detectDeviceType();
  }


  ngOnInit(): void {
    this.getLocation();
    if (localStorage.getItem('marieTokenAdmin')) {
      this.getUserDetails();
    }
  }



  detectDeviceType() {
    const mobileWidth = 768; // Define your mobile width threshold

    if (window.innerWidth < mobileWidth) {
      this.isMobile = true;
      // For example, add a class to an element based on device type
      this.renderer.addClass(document.body, 'mobile-device');
    } else {
      this.isMobile = false;
      this.renderer.addClass(document.body, 'non-mobile-device');
    }
  }

  showMenu() {
    this.showSideMenu.emit();
  }

  getUserName() {
    return localStorage.getItem('name') || 'User'
  }

  /// Redux comment done
  // count$: Observable<number>;
  // constructor(private store: Store<{ count: number }>) {
  //   this.count$ = store.select('count');
  // }


  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        if (position) {
          console.log("Latitude: " + position.coords.latitude +
            " Longitude: " + position.coords.longitude);
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
          this.utility.lat = this.lat
          this.utility.lng = this.lng
          this.getLocationDetails(this.lat, this.lng);
        }
      },
        (error: any) => console.log(error));
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }



 getPlaces(value: any) {
    this.showLoading1 = true;
    this.homeService.fetchPlaces(value.value).then((res) => {
      if (res.status == "SUCCESS") {
        this.placeList = res.data;
        this.showLoading1 = false;
      }
      else {
        console.log(res.message);
      }
    })
  }

  checkUserLoggedIn() {
    return localStorage.getItem("marieTokenAdmin") == null;
  }

  logoutUser() {
    localStorage.clear();
    this.router.navigateByUrl(`/`);
    this.customSnackbarService.openCustomSnackbar('User logged out successfully.');
    this.validationService.setFilterData([]);
    this.logOut.logoutUser().then((res) => {
    }).catch((error) => {
      console.log(error);
    })
  }

  searchData(search: any) {
    this.showLoading = true;
    // console.log("search ", search.target.value);
    this.homeService.searchMarketPlace(this.lat, this.lng, search.target.value, this.place).then((res) => {
      if (res.status == ResponseStatus.SUCCESS) {
        // console.log("data ", res.data);
        this.searchedData = res.data;
        this.showLoading = false;
      }
    })
  }

  getPlaceId(address: any, placeId: any) {
    this.place = placeId;
    this.address = address;
  }

  getLocationDetails(latitude: number, longitude: number) {
    const apiUrl = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`;

    this.http.get(apiUrl).subscribe(
      (data: any) => {
        // Extract location details from the API response
        this.pinCode = data.address.postcode;
        this.country = data.address.country;
        this.city = data.address.city ? data.address.city : data.address.village;
        // this.village = data.address.village;
        // Use location details as needed
        this.address = `${this?.pinCode ?? ""} ${this?.city ?? ""} ${this?.country ?? ""}`


      }
    )
  }


  getUserDetails() {
    this.register.fetchUserDetails().then((res:any) => {
      if (res.data.status = ResponseStatus.SUCCESS) {

      }

    }).catch((err:any)=>{
      if(err.response.status === 403){
        localStorage.clear();
        this.router.navigateByUrl(`/`);
        this.logOut.logoutUser().then((res) => {
        }).catch((error) => {
          console.log(error);
        })
      }
    })
  }


}
